import { __extends } from "tslib";
import { ApplicationDomain } from '../system/ApplicationDomain';
import { ASObject } from '@awayfl/avm2';
/**
 * The LoaderContext class provides options for loading SWF files and other
 * media by using the Loader class. The LoaderContext class is used as the
 * `context` parameter in the `load()` and `loadBytes()` methods of the
 * Loader class.
 *
 * When loading SWF files with the `Loader.load()` method, you have two
 * decisions to make: into which security domain the loaded SWF file should
 * be placed, and into which application domain within that security domain?
 * For more details on these choices, see the `applicationDomain` and
 * `securityDomain` properties.
 *
 * When loading a SWF file with the `Loader.loadBytes()` method, you have the
 * same application domain choice to make as for `Loader.load()`, but it's
 * not necessary to specify a security domain, because `Loader.loadBytes()`
 * always places its loaded SWF file into the security domain of the loading
 * SWF file.
 *
 * When loading images (JPEG, GIF, or PNG) instead of SWF files, there is no
 * need to specify a SecurityDomain or an application domain, because those
 * concepts are meaningful only for SWF files. Instead, you have only one
 * decision to make: do you need programmatic access to the pixels of the
 * loaded image? If so, see the `checkPolicyFile` property. If you want to
 * apply deblocking when loading an image, use the JPEGLoaderContext class
 * instead of the LoaderContext class.
 */
var LoaderContext = /** @class */ (function (_super) {
    __extends(LoaderContext, _super);
    /**
     * Creates a new LoaderContext object, with the specified settings. For
     * complete details on these settings, see the descriptions of the
     * properties of this class.
     *
     * @param checkPolicyFile   Specifies whether a check should be made for
     *                          the existence of a URL policy file before
     *                          loading the object.
     * @param applicationDomain Specifies the ApplicationDomain object to use
     *                          for a Loader object.
     * @param securityDomain    Specifies the SecurityDomain object to use
     *                          for a Loader object.
     *                          _Note:_ Content in the air application
     *                          security sandbox cannot load content from
     *                          other sandboxes into its SecurityDomain.
     */
    function LoaderContext(checkPolicyFile, applicationDomain, securityDomain) {
        if (checkPolicyFile === void 0) { checkPolicyFile = false; }
        if (applicationDomain === void 0) { applicationDomain = null; }
        if (securityDomain === void 0) { securityDomain = null; }
        var _this = _super.call(this) || this;
        var sec = _this.sec;
        _this.checkPolicyFile = checkPolicyFile;
        _this.applicationDomain =
            applicationDomain || new sec.flash.system.ApplicationDomain(ApplicationDomain.currentDomain);
        _this.securityDomain = securityDomain;
        return _this;
    }
    return LoaderContext;
}(ASObject));
export { LoaderContext };
